import { AffairesAaData } from './AffairesAaData';

export class FiltresQuery {
  query_aff: string = "";
  having: string = "";
  query_opp: string = "";
}
export class AffairesList {

  aaData: AffairesAaData[];
  filtres_query: FiltresQuery;
  iTotalDisplayRecords: number = 0;
  iTotalRecords: number = 0;
  min_date_deff : string = "";
  max_date_deff :string = "";
  min_date_creation : string = "";
  max_date_creation  :string = "";

}
